<template>
  <Privacy />
</template>

<script setup>
import Privacy from '@/sections/privacy/Privacy.vue';
</script>
